import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { IChatMessage, IChatOutgoingMessage } from '@cakeiteasy/web-utils';


/**
 * REST side of a chat conversation. Implemented per app, because the route names live in each
 * app's own `default-api.ts` and the conversation is identified by an HTTP interceptor header.
 *
 * `sendMessage` is here because the socket-preferred write path falls back to it, and returns
 * the server's full message list rather than the single created message.
 */
export interface IChatConversationGateway {
  getMessages(): Observable<IChatMessage[]>;
  markRead(): Observable<void>;
  sendMessage(message: IChatOutgoingMessage): Observable<IChatMessage[]>;
}

export const CHAT_CONVERSATION_GATEWAY = new InjectionToken<IChatConversationGateway>('CHAT_CONVERSATION_GATEWAY');
